export default "__VITE_PUBLIC_ASSET__2410a4e0__"